import script from "./screenmonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./screenmonitor.vue?vue&type=script&setup=true&lang=js"

import "./screenmonitor.vue?vue&type=style&index=0&id=04b11710&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04b11710"]])

export default __exports__